module.exports = __webpack_public_path__ + "img/Nepal_logo.3eee3824.png";